import React from "react";
import { Route, Link, Switch } from 'react-router-dom';
import { Card, Steps, Progress, Row, Col } from 'antd';
import numeral from 'numeral';
import createHashHistory from 'history/createHashHistory';

import Common from './common';
import Lstd from './lstd';
import SzjdLstd from './szjdLstd';
import ZtxyLstd from './ztxyLstd';
import JhyszyLstd from './jhyszyLstd';
import YntzyLstd from './yntzyLstd';
import Ssfp from './ssfp';
import SsfpFa from './ssfp/ssfpFa';
import SsfpFb from './ssfp/ssfpFb';
import Xcfb from './xcfb';
import EszyXcfb from './eszyXcfb';
import AhgsXcfb from './xcfb_ahgs';
import Jxfzcmxx from './jxfzcmxx';
import JfblFxxy from './jfblFxxy';
import JfblFb from './jfbl/jfblFb';
import Jfbl from './jfbl';
import AhgsLstd from './ahgsLstd';
import Dybdd from './dybdd';
import styles from '../index.css';
import defaultPortrait from '../../../styles/images/stuDefault.png';
import NHFetch from "../../../utils/NHFetch";
import { createUuid } from '../../../utils/NHCore';
import PropTypes from 'prop-types';

import Print from "../../../utils/Print";
import PrintTemplate from "../print/printTemplate";
import CdfzxxPrint from '../print/Bdd/cdzyxx/CdzyxxPrint';
import {bdd_school,getBddComponent,basePrintComponent} from '../print/Config';
const Step = Steps.Step;

const hashHistory = createHashHistory();
const basicUrl = '/yxxc/'; //基础请求路径

/**
 * 环节办理页面
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-23 16:46:57
 * Version: 1.0
 * Modify log:
 */
export default class StepForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hjblztData: {},
            hjywxData: [],
            schoolName: '',//学校名称
            year: '',//当前年度
            account: '',//默认账号
            xsxx: [],//学生信息
            kzxxInitData: {},
            nr:[],
            loading: false,//按钮状态
            schoolCode: 'lydx',   //配置信息中的学校编码
            ComponentTemp: basePrintComponent,   //使用报到单的页面组件
            stucjzjxx: '',   //学生采集字段信息
            cwhFlag:true,
            rxfs: '', //入学方式(暂只有安徽工商使用)
            //----------------------//
        }
    }

    componentDidMount() {
        this.getReportSchoolpz();
        this.getCwhFlag();
    }

    componentWillReceiveProps(nextProps) {
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (this.props.hjblztData !== nextProps.hjblztData) {
                this.setState({ hjblztData: hjblztData });
            }
        }

        if ('hjywxData' in nextProps) {
            const hjywxData = nextProps.hjywxData;
            this.setState({ hjywxData: hjywxData });
        }

        //当前环节为 班级分配(安徽工商) 时，显示 "入学方式"
        let {xsid} = this.props.studentData;
        let url = window.location.href;
        if(url.indexOf("ahgsXcfb") > -1){
            this.getRxfsByXsid(xsid);
        } else {
            this.setState({ rxfs: ''})
        }
    }

    getCwhFlag = ()=>{
        NHFetch(basicUrl+'getReadCsxx', "GET", { csbz: 'YXXT_SSXX_SFXSCWH' })
        .then(res => {
            if (res) {
                if (res && res.code === 200) {
                    if(res.data==='false'){
                    this.setState({ cwhFlag: false });
                    }
                }
            }
        });  
    }

    // 获取学校（报到单）参数
    getReportSchoolpz = () => {
        let csbz = 'YXXT_BDD_SCHOOL';
        NHFetch(basicUrl + 'getReadCsxx', 'GET', {csbz:csbz})
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ schoolCode: data },()=>{
                            // 获取的学校编号，根据学校编号查出相应的报到单
                            let schoolCode = this.state.schoolCode;
                            this.setState({
                                ComponentTemp: getBddComponent(schoolCode,'PrintComponent') ? getBddComponent(schoolCode,'PrintComponent') : basePrintComponent
                            })
                        });
                    }
                }
            });
    }

    //获取环节办理状态信息
    getHjblztData = (params) => {

        NHFetch(basicUrl + 'getHjblztByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjblztData: data });
                    } else {
                        this.setState({ hjblztData: {} });
                    }
                }
            });
    }

    //获取环节业务项信息
    getHjywxData = (params) => {
        NHFetch(basicUrl + 'getHjywxByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjywxData: data });
                    } else {
                        this.setState({ hjywxData: [] });
                    }
                }
            });
    }

    //获取环节办理信息
    getHjblxx = (hjid, lchjid) => {
        let studentData = this.props.studentData;
        let hjblxxFilter = {};
        hjblxxFilter.xsid = studentData.xsid;
        hjblxxFilter.hjid = hjid;
        hjblxxFilter.lchjid = lchjid;
        this.getHjblztData(hjblxxFilter);

        if (studentData.xsid) {
            this.getHjywxData(hjblxxFilter);
        }
    }

    //解析url搜索参数
    parseUrlParams() {
        let location = this.props.location;
        if (location) {
            const { search } = location;
            if (search) {
                let deocodeUrl = decodeURIComponent(search);
                let url = deocodeUrl.substring(1, search.length); //去除?
                let paramsStr = url.split('&'); //分割参数字符串

                if (paramsStr.length > 0) {

                    let params = {};
                    //解析成键值对形式对象
                    for (let key in paramsStr) {
                        let paramStr = paramsStr[key];
                        let paramObj = paramStr.split('=');
                        let obj = new Object;
                        obj[paramObj[0]] = paramObj[1];
                        Object.assign(params, obj);
                    }

                    return params;
                }
            }
        }
        return null;
    }

    // 获取路径中的当前步骤
    getCurrentStep() {
        let params = this.parseUrlParams();
        if (params) {
            return Number(params.key ? params.key : 0);
        }
    }

    //步骤条点击回调
    handleStepClick = (url, search, hjid, lchjid, stepNum) => {
        this.getHjblxx(hjid, lchjid);
        hashHistory.push({
            pathname: url,
            search: search
        });
    }

    //根据学生ID获取 "入学方式"
    getRxfsByXsid = (xsid) =>{
        NHFetch(basicUrl + "getStuRxfsByXsid", 'GET', {xsid: xsid})
            .then(res => {
                if(res && res.data){
                    this.setState({ rxfs: res.data });
                }
            })
    }

    //下一步操作
    handleNextStep = () => {
        const { lchjVOs } = this.props.lcpz;
        let currentStep = this.getCurrentStep();
        let nextStepData;
        let redirectUrl;
        let filter;
        if (lchjVOs && lchjVOs.length > 0) {
            for (let i = 1; i < lchjVOs.length - currentStep; i++) {
                let nextStep = currentStep + i;
                //获取下一步有操作权限、可操作的环节数据，如果没有，则继续往下查找，直到有权限可操作
                nextStepData = lchjVOs.filter(
                    (item, index) => parseInt(index) == parseInt(nextStep) && item.czqx == '1' && item.zt == '1')[0];
                if (nextStepData) {
                    redirectUrl = '/yxxc/step';
                    switch (nextStepData.hjdm) {
                        case 'GD001':
                            //绿色通道
                            redirectUrl += '/lstd';
                            break;
                        case 'GD002':
                            //缴费办理
                            redirectUrl += '/jfbl';
                            break;
                        case 'GD003':
                            //宿舍分配
                            redirectUrl += '/ssfp';
                            break;
                        case 'GD003_1':
                            //宿舍分配（安徽工商）增加走读申请功能
                            redirectUrl += '/ssfpFa';
                            break;
                        case 'GD003_2':
                            //宿舍分配（武汉软件）
                            redirectUrl += '/ssfpFb';
                            break;
                        case 'GD006':
                            //班级分配
                            redirectUrl += '/xcfb';
                            break;
                        case 'GD006_1':
                            //班级分配(恩施职业)
                            redirectUrl += '/eszyXcfb';
                            break;
                        case 'GD006_2':
                            //班级分配(安徽工商)
                            redirectUrl += '/ahgsXcfb';
                            break;
                        case 'GD007_1':
                             //	军训服装（展示尺码信息）
                            redirectUrl += '/jxfzcmxx';
                            break;
                        case 'GD002_1':
                            //缴费办理
                            redirectUrl += '/jfblFxxy';
                            break;
                        case 'GD002_2':
                            //缴费办理
                            redirectUrl += '/jfblFb';
                            break;
                        case 'GD001_1':
                             //绿色通道--深圳技大
                            redirectUrl += '/szjdLstd';
                            break;
                        case 'GD001_3':
                            //绿色通道--昭通学院
                            redirectUrl += '/ztxyLstd';
                            break;
                        case 'GD001_2':
                            //绿色通道--江汉艺术学院
                            redirectUrl += '/jhyszyLstd';
                            break;
                        case 'GD001_4':
                            //绿色通道--云南体职院
                            redirectUrl += '/yntzyLstd';
                            break;
                        case 'GD001_5':
                            //安徽工商--绿色通道
                            redirectUrl += '/ahgsLstd';
                            break;
                        case 'GD010':
                            //打印报到单
                            redirectUrl += '/dybdd';
                            break;
                        default:
                            break;
                    }
                    filter = encodeURIComponent(`key=${nextStep}&lcid=${this.props.lcid}&hjid=${nextStepData.hjid}&lchjid=${nextStepData.pkid}`);
                    break;
                }
            }

            if (nextStepData && redirectUrl && filter) {
                this.getHjblxx(nextStepData.hjid, nextStepData.pkid);
                hashHistory.push({
                    pathname: redirectUrl,
                    search: filter
                });
            }
        }
    }

    //上一步操作
    handleLastStep = () => {
        const { lchjVOs } = this.props.lcpz;
        let currentStep = this.getCurrentStep();
        let lastStepData;
        let redirectUrl;
        let filter;
        if (lchjVOs && lchjVOs.length > 0) {
            for (let i = 1; i <= currentStep; i++) {
                let lastStep = currentStep - i;
                //获取上一步有操作权限、可操作的环节数据，如果没有，则继续往上查找，直到有权限可操作
                lastStepData = lchjVOs.filter(
                    (item, index) => parseInt(index) == parseInt(lastStep) && item.czqx == '1' && item.zt == '1')[0];
                if (lastStepData) {
                    redirectUrl = '/yxxc/step';
                    switch (lastStepData.hjdm) {
                        case 'GD001':
                            //绿色通道
                            redirectUrl += '/lstd';
                            break;
                        case 'GD002':
                            //缴费办理
                            redirectUrl += '/jfbl';
                            break;
                        case 'GD003':
                            //宿舍分配
                            redirectUrl += '/ssfp';
                            break;
                        case 'GD003_1':
                            //宿舍分配（安徽工商）增加走读申请功能
                            redirectUrl += '/ssfpFa';
                            break;
                        case 'GD003_2':
                                //宿舍分配（武汉软件）
                            redirectUrl += '/ssfpFb';
                            break;
                        case 'GD006':
                            //现场分班
                            redirectUrl += '/xcfb';
                            break;
                        case 'GD006_1':
                            //现场分班（恩施职业）
                            redirectUrl += '/eszyXcfb';
                            break;
                        case 'GD006_2':
                        //班级分配(安徽工商)
                        redirectUrl += '/ahgsXcfb';
                        break;
                        case 'GD007_1':
                            //军训服装（展示尺码信息）
                            redirectUrl += '/jxfzcmxx';
                            break;
                        case 'GD002_1':
                            //缴费办理
                            redirectUrl += '/jfblFxxy';
                            break;
                        case 'GD002_2':
                            //缴费办理
                            redirectUrl += '/jfblFb';
                            break;
                        case 'GD001_1':
                            //绿色通道--深圳技大
                            redirectUrl += '/szjdLstd';
                            break;
                        case 'GD001_3':
                        //绿色通道--昭通学院
                        redirectUrl += '/ztxyLstd';
                        case 'GD001_2':
                        //绿色通道--江汉艺术学院
                        redirectUrl += '/jhyszyLstd';
                            break;
                        case 'GD001_4':
                            //绿色通道--云南体职院
                        redirectUrl += '/yntzyLstd';
                            break;
                        case 'GD001_5':
                            //安徽工商--绿色通道
                            redirectUrl += '/ahgsLstd';
                            break;
                        case 'GD010':
                            //打印报到单
                            redirectUrl += '/dybdd';
                            break;
                        default:
                            break;
                    }
                    filter = encodeURIComponent(`key=${lastStep}&lcid=${this.props.lcid}&hjid=${lastStepData.hjid}&lchjid=${lastStepData.pkid}`);
                    break;
                }
            }
            if (lastStepData && redirectUrl && filter) {
                this.getHjblxx(lastStepData.hjid, lastStepData.pkid);
                hashHistory.push({
                    pathname: redirectUrl,
                    search: filter
                });
            }
        }
    }

    //环节办理完成回调
    handleFinish = (flag) => {
        //办理完成回调
        const onFinish = this.props.onFinish;
        if (onFinish) {
            onFinish(flag);
        }
    }

    //自动办理回调
    onAutoHandle =(lchjData) =>{
        this.props.onAutoHandle(lchjData);
    }

    //打印报到单回调
    handlePrint = () => {
        const { xsid } = this.props.studentData;
        const getAccount = this.getAccount(xsid);
        const getCurrentYearAndSchool = this.getCurrentYearAndSchool();
        const getPrintInfo = this.getPrintInfo(xsid);
        const getJcsjXxcjByxsid = this.getJcsjXxcjByxsid(xsid);
        if (xsid) {
            this.setState({ loading: true });
            Promise.all([getAccount, getCurrentYearAndSchool, getPrintInfo, getJcsjXxcjByxsid]).then(res => {
                this.setState({ loading: false });
                this.refs.print.onPrint();
            }).catch(err => {
                this.setState({ loading: false });
            });
        } else {
            message.error("环节办理失败,请先查询学生信息！");
        }
    }

    getAccount = (xsid) => {
        if (xsid == '') {
            message.error("打印出错！");
        }
        return NHFetch("/yxxc/getAccount", "GET", { xsid: xsid })
            .then(resData => {
                if (resData.data != null) {
                    this.setState({ account: resData.data });
                }
            });
    }

    getCurrentYearAndSchool = () => {
        return NHFetch("/yxxc/getCurrentYearAndSchool", "GET")
            .then(resData => {
                if (resData.data != null) {
                    let year = '';
                    let school = '';
                    resData.data.forEach(element => {
                        if (element.NAME == 'year') {
                            year = element.VALUE;
                        }
                        if (element.NAME == 'school') {
                            school = element.VALUE;
                        }
                    });
                
                    this.setState({ year: year, schoolName: school });
                }
            })
    }

    getPrintInfo = (xsid) => {
        if (xsid == '') {
            message.error("打印出错！");
        }
        return NHFetch("/yxxc/getInfoForPrint", 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    let stuXxcj = res.data.stuXxcj;
                    this.setState({xsxx:res.data,kzxxInitData: { ...stuXxcj },loading: false,nr:res.data.xclcList});
                }
            })
    }

    // 获取学生信息采集字段
    getJcsjXxcjByxsid  = (xsid) => {  
        return NHFetch("/yxxc/getJcsjXxcjByxsid", 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    let stucjzjxx = res.data;
                    this.setState({stucjzjxx:stucjzjxx});
                }
            })
    }

    render() {

        const { hjblztData, hjywxData, xsxx, account, year, schoolName, loading,kzxxInitData,nr , ComponentTemp, stucjzjxx,cwhFlag,rxfs } = this.state;
        const { studentData, lcpz, pieData, stepsData, ybllchjData, } = this.props;
        const { lcdyVO, lchjVOs = [] } = lcpz;
        const { bdrs, zrs } = pieData;

        let currentStep = this.getCurrentStep();

        //当前流程环节配置数据
        let lchjData = lchjVOs.filter(item => {
            let lchjid = hjblztData.pkid;
            return item.pkid == lchjid;
        })[0];

        //流程统计数据
        const cardTitle = (
            <div>
                <span>{lcdyVO ? lcdyVO.lcmc : '流程'}进度</span>&nbsp;&nbsp;
                <Progress type="circle" percent={Number(numeral(bdrs / zrs * 100).format('0'))} width={30} />&nbsp;&nbsp;
                <span style={{ fontWeight: 'normal', fontSize: 14 }}>报到人数 <b>{bdrs}</b> / 总人数 {zrs}</span>
            </div>
        )

        //动态构造步骤条
        const stepItems = stepsData.map((item, index) => {
            let url = '/yxxc/step';
            switch (item.hjdm) {
                case 'GD001':
                    //绿色通道
                    url += '/lstd';                  
                    break;
                case 'GD002':
                    //缴费办理
                    url += '/jfbl';
                    break;
                case 'GD003':
                    //宿舍分配
                    url += '/ssfp';
                    break;
                case 'GD003_1':
                    //宿舍分配（安徽工商）增加走读申请功能
                    url += '/ssfpFa';
                    break;
                case 'GD003_2':
                        //宿舍分配（武汉软件
                    url += '/ssfpFb';
                    break;    
                case 'GD006':
                    //班级分配
                    url += '/xcfb';
                    break;
                case 'GD006_1':
                    //班级分配（恩施职业）
                    url += '/eszyXcfb';
                    break;
                case 'GD006_2':
                    //班级分配（安徽工商）
                    url += '/ahgsXcfb';
                    break;
                case 'GD007_1':
                    //军训服装（展示尺码信息）
                    url += '/jxfzcmxx';
                    break;
                case 'GD002_1':
                    //缴费办理
                    url += '/jfblFxxy';
                    break;
                case 'GD002_2':
                    //缴费办理
                    url += '/jfblFb';
                    break;
                case 'GD001_1':
                    //绿色通道--深圳技大
                    url += '/szjdLstd';
                    break;
                case 'GD001_3':
                    //绿色通道--昭通学院
                    url += '/ztxyLstd';
                    break; 
                case 'GD001_2':
                    //绿色通道--江汉艺术职业学院
                    url += '/jhyszyLstd';
                    break;
                case 'GD001_4':
                    //绿色通道--云南体职院
                    url += '/yntzyLstd';
                    break;
                case 'GD001_5':
                    //绿色通道--安徽工商
                    url += '/ahgsLstd';
                    break;
                case 'GD010':
                    //打印报到单
                    url += '/dybdd';
                    break;
                default:
                    break;
            }


            let available = lchjVOs.filter(lchj => lchj.czqx == '1' && lchj.zt == '1' && item.lchjid == lchj.pkid)[0];
            //如果没有操作权限，则不可点击
            if (available) {
                let search = encodeURIComponent(`key=${index}&lcid=${available.lcid}&hjid=${available.hjid}&lchjid=${available.pkid}`);
                return (
                    <Step
                        key={index}
                        status={ybllchjData.indexOf(item.lchjid) != -1 ? 'finish' : 'wait'}
                        title={<a href="javascript:;"
                        onClick={() => this.handleStepClick(url, search, available.hjid, available.pkid, index)}>{item.hjmc}</a>}
                        description={<span><b>{item.blrs}</b>/{item.lcrs}</span>} />
                );
            } else {
                return (
                    <Step
                        key={index}
                        status={ybllchjData.indexOf(item.lchjid) != -1 ? 'finish' : 'wait'}
                        title={item.hjmc}
                        description={<span><b>{item.blrs}</b>/{item.lcrs}</span>}
                    />
                );
            }
        });

        const steps = (
            <Steps type="navigation" current={currentStep} >
                {stepItems}
            </Steps>
        );

        return (

            <div className={styles.process_content}>
                <Card
                    size="large"
                    title={cardTitle}
                    bodyStyle={{ padding: 0 }}
                    extra={<Link to="/yxxc">返回迎新现场</Link>}>
                    <div style={{ borderBottom: '1px solid #e8e8e8' }}>
                        {steps}
                    </div>
                    {/* <ComponentTemp kzxxInitData={kzxxInitData} nr={nr} initFormDate={xsxx} schoolName={schoolName} year={year} account={account} /> */}
                    <Print ref="print"
                        lazyRender={true}
                        insertHead={true}
                        winStyle='toolbar=yes,menubar=yes'
                        iframeStyle={'width:210px;height:297px'}
                        isIframe={false}
                    >   
                    {
                        // schoolCode == 'cdfzxx' ? <CdfzxxPrint kzxxInitData={kzxxInitData} nr={nr} initFormDate={xsxx} schoolName={schoolName} year={year} account={account}/> :
                        // <PrintTemplate kzxxInitData={kzxxInitData} nr={nr} initFormDate={xsxx} schoolName={schoolName} year={year} account={account} />
                        //this.getPrintPz()
                        <ComponentTemp kzxxInitData={kzxxInitData} nr={nr} initFormDate={xsxx} schoolName={schoolName} year={year} account={account} stucjzjxx={stucjzjxx} />
                        
                    }   
                        
                    </Print>
                    <Card title="个人信息" bordered={false}>
                        <Row className={styles.personal}>
                            <Col xl={3} lg={6} md={12} sm={24} xs={24}>
                                <img
                                    src={`api/sm-student/openapi/getStudentPhoto?xsid=${studentData.xsid}&type=10&uuid=${createUuid()}`}
                                    onError={e => {
                                        e.target.src = defaultPortrait
                                    }}
                                    style={{ width: 125, height: 150 }} />
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>姓 名：</span>{studentData.xm}</div>
                                <div><span>性 别：</span>{studentData.xb}</div>
                                <div><span>民 族：</span>{studentData.mz}</div>
                                <div><span>学 院：</span>{studentData.bmmc}</div>
                                <div><span>班 级：</span>{studentData.bjmc}</div>
                            </Col>
                            <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                                <div><span>身份证号：</span>{studentData.sfzjh}</div>
                                <div><span>出生日期：</span>{studentData.csrq}</div>
                                <div><span>学生类型：</span>{studentData.xslb}</div>
                                <div><span>专业名称：</span>{studentData.zymc}</div>
                                <div><span>宿舍信息：</span>{studentData.ssxqmc}-{studentData.ldmc}-{studentData.lcmc}-{studentData.fjmc}{cwhFlag&&studentData.cwh ? '-' + studentData.cwh : ''}</div>
                            </Col>
                            <Col xl={7} lg={12} md={12} sm={24} xs={24}>
                                <div><span>生源地：</span>{studentData.syd}</div>
                                <div><span>联系电话：</span>{studentData.sjhm}</div>
                                {rxfs && <div><span>入学方式：</span>{rxfs}</div>}
                            </Col>
                        </Row>
                        <Switch>
                            <Route exact path="/yxxc/step" render={
                                ({ location }) =>
                                    <Common location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish}
                                        onAutoHandle={this.onAutoHandle}/>
                            } />
                            <Route path="/yxxc/step/lstd" render={
                                ({ location }) =>
                                    <Lstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/jfbl" render={
                                ({ location }) =>
                                    <Jfbl location={location} studentData={studentData}
                                        hjblztData={hjblztData} lchjData={lchjData}
                                        onPrint={this.handlePrint} hasLast={currentStep != 0}
                                        loading={loading}
                                        hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep}
                                        onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/jfblFxxy" render={
                                ({ location }) =>
                                    <JfblFxxy location={location} studentData={studentData}
                                        hjblztData={hjblztData} lchjData={lchjData}
                                        onPrint={this.handlePrint} hasLast={currentStep != 0}
                                        loading={loading}
                                        hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep}
                                        onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/JfblFb" render={
                                ({ location }) =>
                                    <JfblFb location={location} studentData={studentData}
                                        hjblztData={hjblztData} lchjData={lchjData}
                                        onPrint={this.handlePrint} hasLast={currentStep != 0}
                                        loading={loading}
                                        hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep}
                                        onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />

                            <Route exact path="/yxxc/step/ssfp" render={
                                ({ location }) =>
                                    <Ssfp location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/ssfpFa" render={
                                ({ location }) =>
                                    <SsfpFa location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/ssfpFb" render={
                                ({ location }) =>
                                    <SsfpFb location={location} studentData={studentData}
                                        hjblztData={hjblztData} hjywxData={hjywxData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/xcfb" render={
                                ({ location }) =>
                                    <Xcfb location={location} studentData={studentData}
                                          hjblztData={hjblztData} hjywxData={hjywxData}
                                          lchjData={lchjData} onPrint={this.handlePrint}
                                          loading={loading}
                                          hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                          onLast={this.handleLastStep} onNext={this.handleNextStep}
                                          onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/eszyXcfb" render={
                                ({ location }) =>
                                    <EszyXcfb location={location} studentData={studentData}
                                          hjblztData={hjblztData} hjywxData={hjywxData}
                                          lchjData={lchjData} onPrint={this.handlePrint}
                                          loading={loading}
                                          hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                          onLast={this.handleLastStep} onNext={this.handleNextStep}
                                          onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/ahgsXcfb" render={ //安徽工商-现场分班
                                ({ location }) =>
                                    <AhgsXcfb location={location} studentData={studentData}
                                          hjblztData={hjblztData} hjywxData={hjywxData}
                                          lchjData={lchjData} onPrint={this.handlePrint}
                                          loading={loading}
                                          hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                          onLast={this.handleLastStep} onNext={this.handleNextStep}
                                          onFinish={this.handleFinish} />
                            } />
                            <Route exact path="/yxxc/step/jxfzcmxx" render={
                                ({ location }) =>
                                    <Jxfzcmxx location={location} studentData={studentData}
                                          hjblztData={hjblztData} hjywxData={hjywxData}
                                          lchjData={lchjData} onPrint={this.handlePrint}
                                          loading={loading}
                                          hasLast={currentStep !== 0} hasNext={currentStep < stepsData.length - 1}
                                          onLast={this.handleLastStep} onNext={this.handleNextStep}
                                          onFinish={this.handleFinish}  
                                          onAutoHandle={this.onAutoHandle}
                                          autoHandle={false}
                                          />
                            } />
                            <Route path="/yxxc/step/szjdLstd" render={
                                ({ location }) =>
                                    <SzjdLstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/ztxyLstd" render={
                                ({ location }) =>
                                    <ZtxyLstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />    
                            <Route path="/yxxc/step/jhyszyLstd" render={
                                ({ location }) =>
                                    <JhyszyLstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />    
                            <Route path="/yxxc/step/yntzyLstd" render={
                                ({ location }) =>
                                    <YntzyLstd location={location} studentData={studentData} hjblztData={hjblztData}
                                        lchjData={lchjData} onPrint={this.handlePrint}
                                        loading={loading}
                                        hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                        onLast={this.handleLastStep} onNext={this.handleNextStep}
                                        onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/ahgsLstd" render={
                                ({ location }) =>
                                    <AhgsLstd location={location} studentData={studentData} hjblztData={hjblztData}
                                              lchjData={lchjData} onPrint={this.handlePrint}
                                              loading={loading}
                                              hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                              onLast={this.handleLastStep} onNext={this.handleNextStep}
                                              onFinish={this.handleFinish} />} />
                            <Route path="/yxxc/step/dybdd" render={
                                ({ location }) =>
                                    <Dybdd location={location} studentData={studentData} hjblztData={hjblztData}
                                              lchjData={lchjData} onPrint={this.handlePrint}
                                              loading={loading}
                                              hasLast={currentStep != 0} hasNext={currentStep < stepsData.length - 1}
                                              onLast={this.handleLastStep} onNext={this.handleNextStep}
                                              onFinish={this.handleFinish} />} />
                        </Switch>
                    </Card>
                </Card>
            </div>
        )
    }
}

StepForm.propTypes = {
    location: PropTypes.object, //location信息
    lcid: PropTypes.string, //流程ID
    studentData: PropTypes.object, //学生信息
    lcpz: PropTypes.object, //流程配置信息
    pieData: PropTypes.object, //迎新流程统计饼图数据
    stepsData: PropTypes.array, //流程步骤配置信息
    hjblztData: PropTypes.object, //学生环节办理状态信息
    hjywxData: PropTypes.array, //环节业务项信息
    ybllchjData: PropTypes.array,//学生已办理的流程环节
    onFinish: PropTypes.func, //环节办理完成回调
    onAutoHandle: PropTypes.func,   //自动办理方法回调
}


// WEBPACK FOOTER //
// ./components/yxxc/steps/index.js